
import { Field } from 'formik';

export default function PatientDetails({ handleBlur, errors, touched, prefix, handleChange, values }) {

    var zipcodeName = `${prefix}Zipcode`
    var searchRadius = `${prefix}SearchRadius`
    var insuranceName = `${prefix}Insurance`
    return (

        <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="zipcode" className="block text-sm font-medium text-gray-700">Zip Code <span className="text-red-500">*</span></label>
                    <div className="mt-1">
                        <Field
                            name={zipcodeName}
                            type="text"
                            aria-label="Zip Code"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 ${errors[zipcodeName] && touched[zipcodeName] ? 'border-red-500' : 'border-gray-300'}`}
                        />
                        {errors[zipcodeName] && touched[zipcodeName] ? (
                            <p className="mt-1 text-sm text-red-600">{errors[zipcodeName]}</p>
                        ) : null}
                    </div>
                </div>

                <div>
                    <label htmlFor="searchRadius" className="block text-sm font-medium text-gray-700">Preferred Search Radius (in miles)</label>
                    <div className="mt-1">
                        <Field
                            as="select"
                            name={searchRadius}
                            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500"
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                        </Field>
                    </div>
                </div>
            </div>
            <div>
                <label htmlFor="insuranceName" className="block text-sm font-medium text-gray-700">Insurance</label>
                <div className="mt-1">
                    <Field
                        name={insuranceName}
                        type="text"
                        aria-label="Insurance"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500"
                    />
                </div>
            </div>
        </div>

    );
}